import { path, } from 'utils/ua';
import SocialButtonsBaseVm from './SocialButtonsBaseVm';

export default class FooterSocialButtonsVm extends SocialButtonsBaseVm {

  get shouldRenderButtons() {
    return super.isBottomComponent || path.isKitchenSink;
  }

}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/socialButtons/FooterSocialButtonsVm.js